import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import { useActionChoices } from "stores";
import { FormAutocomplete } from "form";
import { actionInputName } from "components/action-modal/utils/inputName";
import { useFilteredFertilizers } from "./useFilteredFertilizers";

const FertilizerInput = ({ fertilizers, isProposed, isViewMode }) => {
  const { t } = useTranslation();
  const { values } = useFormikContext();
  const { actions } = useActionChoices();
  const { operations } = actions.fertilize;

  const operationOptions = useMemo(() => {
    return (
      operations?.map(
        ({ operationType, operationTypeName, operationTypeId }) => ({
          value: operationTypeId,
          label: operationTypeName,
          operationType,
        }),
      ) || []
    );
  }, [operations]);

  const { fertilizerOptions, handleFertilizerChange } = useFilteredFertilizers({
    fertilizers,
    operationOptions,
    isProposed,
    isViewMode,
  });

  return (
    <FormAutocomplete
      name={actionInputName("fertilizeAction", "fertId", isProposed)}
      placeholder={t("ActionModal.FertilizerComposition")}
      shouldHaveErrorBehaviorAfterSubmit
      isViewMode={isViewMode}
      isDisabled={
        !values.fertilizeAction?.operationTypeId ||
        values.fertilizeAction?.bio === undefined
      }
      options={fertilizerOptions}
      onChange={handleFertilizerChange}
    />
  );
};

export default FertilizerInput;
